class CollectionSliderSwitch extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      this.querySelectorAll("span").forEach(element => {
        element.classList.toggle("state--active");
      });

      this.closest("section").querySelectorAll(".collection-slider-stack-item").forEach(element => {
        element.classList.toggle("state--active");
      });
    });
  }
}

customElements.define("collection-slider-switch", CollectionSliderSwitch);

class CollectionSlider extends HTMLElement {
  constructor() {
    super();

    this._initSlider();
    
    this._resizeObserver = new ResizeObserver(() => {
      if (this._slider) {
        this._slider.destroy();
      }
      this._initSlider();
    });
    this._resizeObserver.observe(this);
  }

  _initSlider() {
    if (this.offsetWidth === 0) {
      requestAnimationFrame(() => this._initSlider());
      return;
    }

    let options = {
      cellAlign: "left",
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      groupCells: 4
    };

    if (matchMedia("(max-width: 767px)").matches) {
      options.groupCells = null;
    }

    this._slider = new Flickity(this, options);

    window.addEventListener('load', () => this._slider.resize(), { once: true });

    document.addEventListener("collectionslider:next", (event) => {
      if (this.active()) {
        this._slider.next();
      }
    });

    document.addEventListener("collectionslider:prev", (event) => {
      if (this.active()) {
        this._slider.previous();
      }
    });
  }

  active() {
    return this.parentElement.classList.contains("state--active");
  }
}

customElements.define("collection-slider", CollectionSlider);
